import {
  UPDATE_ACTIVE_PAUSE,
  PAUSE_DIALOG_CONTROL_OPENED,
  PAUSE_DIALOG_CONTROL_TYPE,
  CLEAR_DIALOG_CONTROL,
  SET_SHEDULED_PAUSE_NAME,
  SET_ALERTED_PAUSE,
  SET_PAUSES,
} from '@/store/mutation-types';

const mutations = {
  [UPDATE_ACTIVE_PAUSE](state, { channelName, pauseName }) {
    state.activePauses[channelName] = pauseName;
  },

  [PAUSE_DIALOG_CONTROL_OPENED](state, value) {
    state.dialogControl = { ...state.dialogControl, opened: value };
  },

  [PAUSE_DIALOG_CONTROL_TYPE](state, type) {
    state.dialogControl.type = type;
  },

  [CLEAR_DIALOG_CONTROL](state) {
    state.dialogControl.opened = false;
    state.dialogControl.type = 'general';
  },

  [SET_SHEDULED_PAUSE_NAME](state, { pause, channel }) {
    state.scheduledPauses[channel] = pause;
  },

  [SET_ALERTED_PAUSE](state, params) {
    state.pauseAlerted = params;
  },

  [SET_PAUSES](state, params) {
    state.pauses = params;
  },
};

export default mutations;
